<template>
  <div
    v-if="_value"
    class="on-chart-message"
    :style="{ minWidth }"
    v-on="$listeners">
    <slot />
    <IconButton
      v-if="showCloseButton"
      class="on-chart-message__close-button"
      icon="close"
      color="secondary"
      @click.stop="_value = false" />
  </div>
</template>

<script>
import IconButton from '@/components/parts/IconButton.vue'

/**
 * @description このコンポーネントはグラフの上に表示するメッセージです
 */
export default {
  components: {
    IconButton
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: null
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.on-chart-message {
  position: relative;

  border: 1px solid $primary;
  padding: 4px 20px;
  background-color: rgba(255, 255, 255, 0.75);
  text-align: center;
  color: $primary;
  font-size: 18px;
  font-weight: bold;

  &__close-button {
    position: absolute;
    top: -16px;
    right: -16px;
  }
}
</style>